import {PaginatorProps} from "./types";
import {
  ChevronLeftIcon, ChevronDoubleLeftIcon,
  ChevronRightIcon, ChevronDoubleRightIcon,
} from "@heroicons/react/24/solid";
import Input from "@ui-components/Input";
import {FormattedMessage} from "react-intl";
import React, {useEffect, useState} from "react";


export const Paginator = ({pageSize, currentPage, totalItems, setPage}: PaginatorProps) => {

  // state
  const [goPageInput, setGoPageInput] = useState<number>(0);

  // utilities
  const pageCount = totalItems !== undefined ? Math.ceil(totalItems / pageSize) : 0;
  const disabledLeft = currentPage === 0;
  const disabledRight = currentPage >= pageCount - 1;
  const iconCls = (disabled: boolean) => `w-4 inline-block ${disabled ? "cursor-not-allowed text-gray-400" : "cursor-pointer"}`;

  useEffect(() => {
    setGoPageInput(currentPage);
  }, [currentPage]);

  if (pageCount < 1)
    return null;

  return (
    <div className={"flex flex-col items-end justify-between md:flex-row md:items-center gap-1"}>
      <div className={"flex flex-row items-center justify start gap-12"}>
        <div className={"flex ml-4 mr-4 items-center justify-between gap-4"}>
          <ChevronDoubleLeftIcon
            className={iconCls(disabledLeft)}
            onClick={() => {
              if (disabledLeft) return;
              setPage(0);
            }}
          />
          <ChevronLeftIcon
            className={iconCls(disabledLeft)}
            onClick={() => {
              if (disabledLeft) return;
              setPage(currentPage - 1);
            }}
          />
          <div className="whitespace-nowrap">
            <span className={"font-semibold text-center"}>{currentPage + 1}</span>{" "}
            <span className={"text-center"}>/ {pageCount}</span>
          </div>
          <ChevronRightIcon
            className={iconCls(disabledRight)}
            onClick={() => {
              if (disabledRight) return;
              setPage(currentPage + 1);
            }}
          />
          <ChevronDoubleRightIcon
            className={iconCls(disabledRight)}
            onClick={() => {
              if (disabledRight) return;
              setPage(pageCount - 1);
            }}
          />
        </div>
        <div className={"flex flex-row items-center gap-2"}>
          <span className="text-xs whitespace-nowrap">
            <FormattedMessage id={"go_to_page"} defaultMessage={"Vai a pagina"}/>
          </span>
          {/* @ts-ignore */}
          <Input
            type={"number"}
            value={goPageInput + 1}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
              const newPage = parseInt(e.target.value) - 1;
              if (newPage < 0 || newPage >= pageCount)
                return;
              setGoPageInput(newPage);
              if (!isNaN(newPage) && 0 <= newPage && newPage < pageCount)
                setPage(newPage);
            }}
            min={1}
            max={pageCount}
            step={1}
            hideBottomMargin
          />
        </div>
      </div>
      <div className="text-xs text-gray-500">
        {totalItems} <FormattedMessage id={"items"} defaultMessage={"elementi"}/>
      </div>
    </div>
  );
}